/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShadow = createReactComponent("outline", "shadow", "IconShadow", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13 12h5", "key": "svg-1" }], ["path", { "d": "M13 15h4", "key": "svg-2" }], ["path", { "d": "M13 18h1", "key": "svg-3" }], ["path", { "d": "M13 9h4", "key": "svg-4" }], ["path", { "d": "M13 6h1", "key": "svg-5" }]]);

export { IconShadow as default };
//# sourceMappingURL=IconShadow.mjs.map
